"use client";

import { createPath } from "@/service/routing/routing";
import { RatingCard } from "@/components/doctor-training/rating-card";
import { SeatsCard } from "@/components/doctor-training/seats-card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";

export const ResidencyPreset = ({
  facility,
  unitGroups,
}: {
  facility: MedicalFacility;
  unitGroups: MedicalFacilityUnitGroup[];
}) => {
  return (
    <div className={"@container flex flex-col gap-6"}>
      {unitGroups.map(({ specialization, units }, index) => (
        <UnitGroup
          key={specialization.title}
          specialization={specialization}
          units={units}
          facility={facility}
          index={index}
        />
      ))}
    </div>
  );
};

function UnitGroup({
  specialization,
  units,
  facility,
  index,
}: {
  specialization: MedicalFacilityUnitGroupSpecialization;
  units: MedicalFacilityUnitCard[];
  facility: MedicalFacility;
  index: number;
}) {
  const { title } = specialization;
  return (
    <div
      key={title}
      className={
        "@704:p-8 relative mt-3 flex flex-col gap-3 rounded-lg border p-6"
      }
    >
      <Badge
        className={
          "absolute top-[-8px] left-3 z-10 bg-[#e0ebff] text-[#122258] opacity-100"
        }
      >
        {title}
      </Badge>
      {units.map(({ title, medicalTrainingRating, seats, slug }) => (
        <div
          key={title}
          className={
            "@704:flex-row @704:items-center @704:justify-between flex flex-col gap-1"
          }
        >
          <a
            className="hover:text-remedium-blue w-full text-sm font-normal text-zinc-950"
            href={createPath("residency_map.facility.unit.index", {
              facilitySlug: facility.slug,
              unitSlug: slug,
            })}
          >
            {title}
          </a>
          <div
            className={"@704:gap-8 @704:w-auto flex w-full items-center gap-4"}
          >
            <div className={"w-[80px]"}>
              <RatingCard rating={medicalTrainingRating} />
            </div>
            <div className={"w-[90px]"}>
              <SeatsCard seats={seats} />
            </div>
            <Button
              asChild={true}
              variant={"outline"}
              className="@704: ml-auto"
            >
              <Link
                href={createPath("residency_map.facility.unit.index", {
                  facilitySlug: facility.slug,
                  unitSlug: slug,
                })}
              >
                Zobacz
              </Link>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
